export const Config = {
  API_URI: process.env.API_URI,
  APP_URI: process.env.APP_URI,
  WEBSOCKET_URI: process.env.WEBSOCKET_URI,
  SPOTIFY_CLIENT_ID: process.env.SPOTIFY_CLIENT_ID,
  FACEBOOK_APP_ID: process.env.FACEBOOK_APP_ID,
  WEB_URI: process.env.APP_URI,
};
